import { computed, type ComputedRef } from 'vue';
import { useRemoteConfigStore } from '../stores/remoteConfig.store';

export interface UseCredentialApiFlagReturn {
  isEnabled: ComputedRef<boolean>;
}

export function useCredentialApiFlag(): UseCredentialApiFlagReturn {
  const remoteConfigStore = useRemoteConfigStore();
  const config = remoteConfigStore.getFeatureFlag('feature_credential_api');

  const isEnabled = computed<boolean>(() => config.value.enabled);

  return { isEnabled };
}
